import {combineReducers} from 'redux'
import todoReducer from './home/homeReducer'
import authReducer from './auth/authReducer'
import userReducer from './user/userReducer'
import cursosReducer from './cursos/cursosReducer'
const rootReducer = combineReducers({
    home: todoReducer,
    auth: authReducer,
    user: userReducer,
    curso:cursosReducer
})

export default rootReducer;